import { render, staticRenderFns } from "./BaseTextEditorDisplay.vue?vue&type=template&id=6bacf546&"
import script from "./BaseTextEditorDisplay.vue?vue&type=script&lang=js&"
export * from "./BaseTextEditorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports